import _ from 'lodash'

import { defaultInstance } from 'services'

// import { randomString } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const mapFieldSection = (item, parentId) => {
  const id = item?.section_id
  // const value = `section_id-${randomString(5)}-${id}`
  const value = `${parentId}-${id}`
  return {
    title: item?.section_name,
    value: value,
    key: value,
  }
}

const mapFieldDepartment = (item, parentId) => {
  const id = item?.department_id
  // const value = `department_id-${randomString(5)}-${id}`
  const value = `${parentId}-${id}`
  return {
    title: item?.depart_name,
    value: value,
    key: value,
    children: _.map(item?.section, (c) => mapFieldSection(c, value)),
  }
}

const mapFieldDivision = (item, parentId) => {
  const id = item?.division_id
  // const value = `division_id-${randomString(5)}-${id}`
  const value = `${parentId}-${id}`
  return {
    title: item?.division_name,
    value: value,
    key: value,
    children: _.map(item?.department, (c) => mapFieldDepartment(c, value)),
  }
}

const mapFieldBU = (item, parentId) => {
  const id = item?.bu_id
  // const value = `bu_id-${randomString(5)}-${id}`
  const value = `${parentId}-${id}`
  return {
    title: item?.bu_name,
    value: value,
    key: value,
    children: _.map(item?.division, (c) => mapFieldDivision(c, value)),
  }
}

const mapFieldGroup = (item, parentId) => {
  const id = item?.group_id
  // const value = `group_id-${randomString(5)}-${id}`
  const value = `${parentId}-${id}`
  return {
    title: item?.group_name,
    value: value,
    key: value,
    children: _.map(item?.business_unit, (c) => mapFieldBU(c, value)),
  }
}

export const mapFieldOrganization = (item) => {
  const id = item?.company_id
  // const value = `company_id-${randomString(5)}-${id}`
  const value = id
  return {
    title: item?.company_name,
    value: value,
    key: value,
    children: _.map(item?.group, (c) => mapFieldGroup(c, value)),
  }
}

export const getOrganizationFilterListApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldOrganization) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
